import React from 'react'

const Loading = (showLoading) => {
    return (
        <div className="loading-area">
            <div className="loading-box"></div>
            <div className="loading-pic">
                <div className="windows8">
                    <div className="wBall" id="wBall_1">
                        <div className="wInnerBall"></div>
                    </div>
                    <div className="wBall" id="wBall_2">
                        <div className="wInnerBall"></div>
                    </div>
                    <div className="wBall" id="wBall_3">
                        <div className="wInnerBall"></div>
                    </div>
                    <div className="wBall" id="wBall_4">
                        <div className="wInnerBall"></div>
                    </div>
                    <div className="wBall" id="wBall_5">
                        <div className="wInnerBall"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Loading
